import { types } from 'mobx-state-tree'

export const UserStore = types.model({
    id: types.number,
    firstName: types.string,
    lastName: types.string,
    userName: types.string,
})
